var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgForwardArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 71,
    height: 27,
    fill: "none",
    viewBox: "0 0 71 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#618DA5",
    clipPath: "url(#forward-arrow_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.149 12.076 63.512-2.64a3.837 3.837 0 0 1 3.997 3.682 3.837 3.837 0 0 1-3.682 3.997h-.321l-63.506-2.64A1.2 1.2 0 0 1 0 13.225a1.21 1.21 0 0 1 1.149-1.149"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m61.429.861 8.834 9.994a2.97 2.97 0 0 1 .157 3.738L62.307 25.51a2.535 2.535 0 0 1-3.547.523 2.547 2.547 0 0 1-.653-3.355l7.088-11.61.158 3.739-7.87-10.77c-1.825-2.64 1.762-5.518 3.946-3.176"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "forward-arrow_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h71v26.54H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForwardArrow);
export default __webpack_public_path__ + "static/media/forward-arrow.dc05f1a392f9cecc5f71b950be61b327.svg";
export { ForwardRef as ReactComponent };